/**
 * Where a result message ("Good effort! Try again.") goes in an exercise that
 * shows a staff: below the music, never on top of it.
 */

/** Clear space kept between the music and the message, and between the message and the camera edge. */
export const RESULT_MESSAGE_GAP_PX = 32;

/**
 * Top edge for a message placed below the music. If the music reaches so low
 * that the message would leave the camera, the message is held inside it.
 */
export function messageTopBelowNotation(
  notationBottom: number,
  messageHeight: number,
  cameraHeight: number,
): number {
  const lowestTopInsideCamera = cameraHeight - messageHeight - RESULT_MESSAGE_GAP_PX;
  return Math.min(notationBottom + RESULT_MESSAGE_GAP_PX, lowestTopInsideCamera);
}
